import React from "react";
import { Link, useHistory } from "react-router-dom";
import style from "./index.module.scss";
import classNames from "classnames";
import { Badge } from "antd";
import { useAtomValue } from "jotai";
import { unReadCountAtom } from "../../store";

export default function NavBar() {
    const history = useHistory();

    const counts = useAtomValue(unReadCountAtom);

    function isMatch(path: string) {
        return history.location.pathname.indexOf(path) !== -1;
    }

    return (
        <div className={style.root}>
            <div className={style.links}>
                <Link
                    replace
                    className={classNames(style.link, {
                        [style.current]: isMatch("/send")
                    })}
                    to="send">
                    我发出的
                </Link>
                <Link
                    replace
                    className={classNames(style.link, {
                        [style.current]: isMatch("/receive")
                    })}
                    to="receive">
                    {!!counts ? <Badge dot>我收到的</Badge> : "我收到的"}
                </Link>
            </div>
        </div>
    );
}
